import { getAnyAccessToken, SSCIAM_ACCESS_TOKEN_KEY } from "./authHelper";

// check if a user has been migrated to sscIam by checking if they exist in the user-manager
export const isUserMigratedToSscIam = async (portal2Host, userEmail) => {
  const accessToken = getAnyAccessToken(); // both ssciam and cognito token should work for this

  if (!accessToken) {
    throw new Error("No valid access token found");
  }

  const encodedEmail = encodeURIComponent(userEmail);
  const response = await fetch(`${portal2Host}/user-manager/users?email=${encodedEmail}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok && response.status === 401) {
    throw new Error("You seem to be unauthorized to perform this action. Please check your credentials.");
  }

  if (!response.ok) {
    const data = await response.json();
    throw new Error(`Failed to check user migration status: ${data.status} - ${data.statusText}`);
  }

  const data = await response.json();
  // If the user exists in the array, they are migrated
  return Array.isArray(data) && data.length > 0;
};

export const sscIamImpersonate = async (dxGateway, merchantId, impersonateEmail) => {
  const accessToken = window.localStorage.getItem(SSCIAM_ACCESS_TOKEN_KEY);
  const encodedEmail = encodeURIComponent(impersonateEmail);

  if (!accessToken) {
    throw new Error("No SSC IAM access token found");
  }

  const response = await fetch(
    `${dxGateway}/v1/merchants/${merchantId}/users/${encodedEmail}/impersonate/delegate/initiate`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    const data = await response.json();
    throw new Error(
      `Failed to impersonate User: ${impersonateEmail} - Status: ${response.status} - Message: ${
        data.title || data.message || "Unknown error"
      }`
    );
  }

  return await response.text();
};
